export default __webpack_public_path__ + "static/media/kryptos.0b35cc82.jpg";